import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import { ClaustraDestinationId, ClaustraMobilityId, ClaustraTypeId } from '@core/constants/Shape';
import { MaterialId } from '@core/constants/Material';
import { FieldDimensionId } from '@core/constants/FieldDimension';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
    IFormInputType,
    IDimensionUnit,
} from '../../interfaces/Form';
import fieldsContact from './common/fieldsContact';
import additionalDataFactory from './common/fieldsAdditionalData';
import {
    allGlasses,
    allMetals,
    allPlastics,
    allSolidWoods,
    getMaterialsWithExceptions,
} from './common/materialGroups';

const claustraForm: IForm = {
    formId       : PublishedFormId.Claustras,
    type         : FormTypeId.Claustra,
    thumbnailURL : '/resized-images/forms/claustra.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.ClaustraDestination,
        IFormFieldKey.ClaustraMobility,
        IFormFieldKey.ClaustraType,
        IFormFieldKey.Material,
        IFormFieldKey.Dimension,
        IFormFieldKey.ClaustraLaying,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        claustraDestination: {
            value   : undefined,
            options : [
                ClaustraDestinationId.ClaustraIndoor,
                ClaustraDestinationId.ClaustraOutdoor,
            ],
            required: true,
        },
        claustraMobility: {
            value   : undefined,
            options : [
                ClaustraMobilityId.ClaustraFixed,
                ClaustraMobilityId.ClaustraMobile,
                ClaustraMobilityId.ClaustraSemiMobile,
            ],
            required: true,
        },
        claustraType: {
            value   : undefined,
            options : [
                ClaustraTypeId.ClaustraOpenWork,
                ClaustraTypeId.ClaustraSolid,
            ],
            required: true,
        },
        material: {
            material: {
                value   : undefined,
                options : getMaterialsWithExceptions(
                    [
                        ...allSolidWoods,
                        ...allMetals,
                        ...allGlasses,
                        ...allPlastics,
                    ],
                    [
                        MaterialId.Poplar,
                        MaterialId.Ebony,
                        MaterialId.Elm,
                        MaterialId.Alderwood,
                        MaterialId.Mahogany,
                        MaterialId.AshOlive,
                        MaterialId.OakOld,
                        MaterialId.WagonfloorDark,
                        MaterialId.WagonfloorLight,
                        MaterialId.Rust,
                        MaterialId.Brass,
                        MaterialId.SheetMetal,
                        MaterialId.StainlessSteel,
                        MaterialId.Zinc,
                        MaterialId.RecycledPlastic,
                    ],
                ),
                required: true,
            },
        },
        dimension: {
            [FieldDimensionId.Height]: {
                value        : undefined,
                type         : IFormInputType.Range,
                unit         : IDimensionUnit.Centimeters,
                step         : 100,
                range        : { min: 500, max: 2500 },
                required     : true,
                defaultValue : 1000,
            },
            [FieldDimensionId.Length]: {
                value        : undefined,
                type         : IFormInputType.Range,
                unit         : IDimensionUnit.Centimeters,
                step         : 100,
                range        : { min: 800, max: 4000 },
                required     : true,
                defaultValue : 1500,
            },
        },
        claustraLaying: {
            value: undefined,
        },
        additionalData: additionalDataFactory({
            budgetMin          : 1300,
            budgetMax          : 5000,
            budgetDefaultValue : 2700,
        }),
        contact: fieldsContact,
    },
};

export default claustraForm;
